// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestReopenResolveBody = {
  poolId: string;
  contestId: string;
  decision: "accept" | "reject" | "editAndApply";
  previewResultsDigest: string;
  override?: {
    entries: {
      entryId: string;
      status: "in" | "eliminated" | "revived";
      pointsTotal: number;
      livesRemaining: number;
    }[];
    winnerEntryIds: string[];
    seasonTrophyHolderUserIds?: string[] | null;
  } | null;
};

export type typeContestReopenResolveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    status: "confirmed";
    decision: "accept" | "reject" | "editAndApply";
    resolvedAt: string;
    didOutcomeMove: boolean;
    movedFacets: string[];
    winnerEntryIds: string[];
    medalHolderCount: number;
    seasonTrophyHolderUserIds: string[];
  };
};

export type typeContestReopenResolveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestReopenResolveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestReopenResolveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestReopenResolveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    decision: { type: "string", enum: ["accept", "reject", "editAndApply"] },
    previewResultsDigest: { type: "string", maxLength: 3000, minLength: 1 },
    override: {
      oneOf: [
        {
          type: "object",
          properties: {
            entries: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  entryId: { type: "string", maxLength: 3000, minLength: 1 },
                  status: {
                    type: "string",
                    enum: ["in", "eliminated", "revived"],
                  },
                  pointsTotal: { type: "integer" },
                  livesRemaining: { type: "integer" },
                },
                required: [
                  "entryId",
                  "status",
                  "pointsTotal",
                  "livesRemaining",
                ],
              },
            },
            winnerEntryIds: {
              type: "array",
              items: { type: "string", maxLength: 3000, minLength: 1 },
            },
            seasonTrophyHolderUserIds: {
              oneOf: [
                {
                  type: "array",
                  items: { type: "string", maxLength: 3000, minLength: 1 },
                },
                { enum: [null] },
              ],
            },
          },
          required: ["entries", "winnerEntryIds"],
        },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "contestId", "decision", "previewResultsDigest"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestReopenResolve(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestReopenResolveBody);
  }

  return async function postContestReopenResolve(
    payload: typeContestReopenResolveBody,
  ): Promise<
    typeContestReopenResolveOutput200 | typeContestReopenResolveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestReopenResolve" failed before calling the network. #e50e0e064469`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e50e0e064469" },
        },
        data: null,
      } as typeContestReopenResolveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/reopen-resolve`,
      httpMethod: "POST",
      options,
    })) as
      typeContestReopenResolveOutput200 | typeContestReopenResolveOutput400;
  };
}
